var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"suivi-recla"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.loaded)?_c('router-view'):_c('b-overlay',{staticClass:"overlay",attrs:{"show":true,"rounded":"sm"}},[_vm._v(" Chargement en cours... ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }